export default "__VITE_ASSET__3e91bb37__"